/**checkInput**/
<template>
  <div class="checkInput clear" @click="checkInputAcFn(val)">
    <span class="inputImg" v-if="!stateFn"><img src="../../../../assets/img/yonghu/inputNo.png"></span>
    <span class="inputImg" v-else=""><img src="../../../../assets/img/yonghu/inputYes.png"></span>
    <span class="val">{{text}}</span>
  </div>
</template>

<script>
  export default {
    name: 'xk-checkInput',
    props: ['val', 'forbid', 'showState', 'text'],
    computed: {
      stateFn: function () {
        if (this.$props.forbid) {
          return this.$props.showState
        }
        return this.state
      }
    },
    data () {
      return {
        state: false
      }
    },
    methods: {
      checkInputAcFn: function (data) {
        if (!this.$props.forbid) {
          this.state = !this.state
          this.$emit('click', {data: data, state: this.state})
        }
      }
    },
    watch: {},
    mounted: function () {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .checkInput {
    .inputImg {
      box-sizing: content-box;
      display: inline-block;
      float: left;
      margin-right: 0.3rem;
      position: relative;
      width: 1rem;
      height: 2.8rem;
      img {
        position: absolute;
        width: 100%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .val {
      float: left;
      width: auto !important;
    }
  }
</style>



// WEBPACK FOOTER //
// checkInput.vue?42cdbac4